// extracted by mini-css-extract-plugin
export default {"bar":"Location_bar__QIQ-f","beat":"Location_beat__VAb+J","tick":"Location_tick__lbrE8"};